// OvalFelt.tsx - the oval table (S19). Renders a FeltView: the opponent ring placed around the oval,
// the community board + pot in the center, and the hero pod docked at the bottom with per-hand hole
// cards. Pure presentation over the bridge's FeltView; no engine logic here.
import type { FeltView } from '../engine/bridge';
import { Card } from './Card';

export interface OvalFeltProps {
  view: FeltView;
}

export function OvalFelt({ view }: OvalFeltProps) {
  // Match the mockup: on the flop all three cards deal in; on the turn/river only the newest card does.
  const dealCount = view.board.length === 3 ? 3 : view.board.length >= 4 ? 1 : 0;
  const dealFrom = view.board.length - dealCount;

  return (
    <div className="tablewrap">
      <div className="felt">
        {view.seats.map((seat, i) => {
          const cls =
            'seat' +
            (seat.out ? ' out' : '') +
            (seat.unread ? ' unread' : '') +
            (seat.active ? ' act' : '');
          return (
            <div key={i} className={cls} style={{ left: seat.layout.left, top: seat.layout.top }}>
              <div className="av">{seat.avatar}</div>
              {seat.button && (
                <span className="btn-d" title="Dealer button">
                  D
                </span>
              )}
              <div className="nm">{seat.name}</div>
              <div className="st num">{seat.stack}</div>
              {/* TB3: the read you built on this seat - it lives on the SESSION, so it survives the hand. */}
              {seat.tag && <div className="readtag">{seat.tag}</div>}
              {seat.out && <div className="foldtag">folded</div>}
              {seat.active && (
                <div className={'bet num' + (seat.bet ? ' chip' : '')}>{seat.bet ?? ''}</div>
              )}
            </div>
          );
        })}

        <div className="center">
          <div className="board">
            {view.board.map((card, i) => (
              <Card key={i} card={card} deal={i >= dealFrom} />
            ))}
          </div>
          <div className="potpill">
            <span className="lab">Pot</span> <span className="num">{view.pot}</span>
          </div>
        </div>

        <div className="hero">
          <div className="cards">
            <Card card={view.heroCards[0]} />
            <Card card={view.heroCards[1]} />
          </div>
          <div className="lab">{view.heroLabel}</div>
          {view.heroHasButton && <span className="btn-static">D</span>}
        </div>
      </div>
    </div>
  );
}
